export { default as ChannelListTemplate } from './ChannelListTemplate';
export { default as ChannelEditTemplate } from './ChannelEditTemplate';
export { default as WarehouseCodesTemplate } from './WarehouseCodesTemplate';
export { default as CustomLabelTemplate } from './CustomLabelTemplate';
export { default as AmazonTemplatesTemplate } from './AmazonTemplatesTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/index.js